import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const CardDuCardRon = (props) => {

    const { t } = useTranslation();

    return (
        <>

            <div className="text-decoration-none text-center mx-auto">  
                <Link className="text-dark" to={'/artistes/' + props.NameURL}>

                    <div >
                        <div className="rounded-circle mx-auto borderBordeaux text-center" style={{backgroundImage: `url(${props.imgCardRond})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", height: "200px", width: "200px"}}></div>
                    </div>
                    
                    <div className='text-center'>
                        <div className="h6">{props.NameArtist}</div>
                        <p className="h7">{t('General.spe')}</p>
                    </div>
                    
                </Link>
            </div> 
            
        </>
    )
}

export default CardDuCardRon
